import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Splitter from '../helpers/Splitter'

import CoursesContainer from '../components/common/Products/CoursesContainer'

const Index = Splitter(() => import('../components/common/Products/Index'))
const AddProduct = Splitter(() => import('../components/manager/products/AddProduct'))
const EditProduct = Splitter(() => import('../components/manager/products/EditProduct'))
const AddProductContent = Splitter(() =>
  import('../components/manager/products/AddProductContent')
)
const EditContent = Splitter(() =>
  import('../components/manager/products/EditProductContent')
)
const PurchaseCourseContainer = Splitter(() =>
  import('../components/common/Products/PurchaseCourseContainer')
)
const ViewProduct = Splitter(() => import('../components/common/Products/ViewCourse'))
const ReviewProduct = Splitter(() => import('../components/manager/ReviewCourse'))

export const productsRoutes = (
  <Route path="products" component={CoursesContainer}>
    <IndexRoute component={Index} />
    <Route path="add" component={AddProduct} />
    <Route path="view/:courseId" component={ViewProduct} />
    <Route path="review/:courseId" component={ReviewProduct} />
    <Route path="edit/:courseId" component={EditProduct} />
    <Route path="edit/:courseId/contents/:attachmentId" component={EditContent} />
    <Route path="update/:courseId/contents" component={AddProductContent} />
    <Route
      path="purchase/:courseId/:courseCode"
      component={PurchaseCourseContainer}
    />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/productsRoutes.js